import React from 'react';
import { FullPageChat } from 'flowise-embed-react';
import { RootState } from '../../redux';
import { useSelector } from 'react-redux';

interface ChatAssistantProps {
    sessionId: string;
    welcomeMessage: string;
    chatId: string;
}

const { REACT_APP_FLOWISE_EMBED_URL, REACT_APP_BACKEND } = process.env;

const ChatAssistant: React.FC<ChatAssistantProps> = ({ sessionId, welcomeMessage, chatId }) => {
    const { matchId } = useSelector((state: RootState) => state.analysis.companies);
    const backend = REACT_APP_BACKEND ?? "";

    return (
        <FullPageChat
            key={sessionId}
            chatflowid={chatId}
            apiHost={REACT_APP_FLOWISE_EMBED_URL}
            chatflowConfig={{
                sessionId: sessionId,
                vars: {
                    xpartners_match_id: matchId,
                    xpartners_url: backend.split('/').slice(0, 3).join('/')
                },
            }}
            // @ts-ignore
            theme={{
                chatWindow: {
                    title: 'Delphi Assistant',
                    welcomeMessage: welcomeMessage,
                    backgroundColor: '#ffffff',
                    titleBackgroundColor: '#2d55e3',
                    titleTextColor: '#ffffff',
                    footer: {
                        text: 'Powered by',
                        company: 'OMMAX Delphi Dialogue',
                        companyLink: 'https://www.ommax.de',
                    },
                },
                customCSS: `
                div[style*="overflow: hidden"][style*="background-color"] {
                    border-top-right-radius: 12px !important;
                    border-bottom-right-radius: 12px !important;
                    height: 70dvh !important;
                }
            `,
            }}
        />
    );
};

export default ChatAssistant;
